import styled from '@emotion/styled';
import { columnGutter, mediaQueries, remCalc, font } from '../../css';
import { StyledTitle } from '../SearchTeaser/SearchTeaser.css';

const StyledTeasersList = styled('div')(() => ({
    marginBottom: remCalc(25),

    [StyledTitle]: {
        fontFamily: font.family.body,
        fontWeight: font.weight.regular,
    },
}));

const StyledContainer = styled('div')(() => ({
    flexWrap: 'wrap',
    alignContent: 'center',
    display: 'flex',
    [mediaQueries.large]: {
        flexWrap: 'nowrap',
    },
}));

const StyledCard = styled('div')(
    () => ({
        overflow: 'hidden',
        flex: '1 1 auto',
        ':nth-child(even)': {
            marginLeft: '1%',
            marginBottom: '1%',
        },
        width: '49%',
        [mediaQueries.large]: {
            ':nth-child(even)': {
                marginLeft: 0,
                marginBottom: 0,
            },
            marginLeft: 0,
            marginRight: columnGutter.medium,
            ':last-child': {
                marginRight: 0,
            },
            width: 'auto',
        },
    }),
    ({ index }) => {
        if (index >= 4) {
            return {
                display: 'none',
                [mediaQueries.large]: {
                    display: 'block',
                },
            };
        }
        return {};
    },
);

const StyledRow = styled('div')(() => ({
    display: 'block',
    [mediaQueries.large]: {
        display: 'none',
    },
}));

export { StyledTeasersList, StyledContainer, StyledCard, StyledRow };
